import * as angular from 'angular';

export default function PlanConfigCtrl($compile, $scope, $rootScope) {
  'ngInject';

  var currentBellCurve;

  $scope.addBellCurve = function (mixRow, benchmarksConfig) {
    // console.group('Inside PlanConfigCtrl.addBellCurve()');
    // console.log('mixRow obj:');
    // console.log(mixRow);

    // console.log('benchmarksGraph obj:');
    // console.log(benchmarksConfig);
    // console.groupEnd();

    var subScope = $scope.$new();

    subScope.benchmarksGraph = benchmarksConfig;

    var el = $compile(
      '<div class="mixPanelBodyCell benchmarksCell"><div benchmarks-graph stuff="benchmarksGraph.data" config="benchmarksGraph.config"></div></div>'
    )(subScope);
    angular.element(mixRow).append(el);

    subScope.$apply();
    subScope.$broadcast('redraw');
  };
}
